<template>
  <div v-loading="tableLoading" class="task-table">
    <base-table
      ref="baseTable"
      default-expand-all
      :data="tableData"
      :show-pointer="showPointer"
      @page-change="pageChange"
      show-line-height-box
      :show-pagination="showPagination"
      :page-info="pageInfo"
      @row-click="rowClick"
      :initial-line-height-level="initialLineHeightLevel"
      @selection-change="handleSelectionChange"
      @initial-line-height-level="space"
      @cell-mouse-enter="cellEnter"
      @cell-mouse-leave="cellLeave"
      @select-all="handleSelectAllChange"
    >
      <el-table-column v-if="showSelection" fixed align="center" width="60" type="selection">
        <template #default="{ row }">
          <div v-if="columnCheckedId === row.id || checkedList[row.index]" @click.stop>
            <el-checkbox v-model="checkedList[row.index]" @change="cellCheckbox(row)"></el-checkbox>
          </div>
          <span class="task-table-index" v-else>{{ row.index }}</span>
        </template>
      </el-table-column>
      <el-table-column v-if="showDeleteBtn" fixed="left" align="center" label="操作" width="60">
        <template slot-scope="scope">
          <el-tooltip content="解除依赖关系" placement="top">
            <el-button
              @click.stop="$emit('delete-click', scope.row)"
              type="space"
              size="small"
              icon="el-icon-delete"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--<el-table-column prop="name" label="dslkf" align="center" min-width="50"></el-table-column>-->
      <el-table-column
        v-for="column in tableColumns"
        :key="column.prop"
        :label="column.label"
        :prop="column.prop"
        :min-width="column.width"
        show-overflow-tooltip
        header-align="center"
        :align="column.contentAlign"
      >
        <template slot-scope="scope">
          <template v-if="column.prop === 'name'">
            <svg-icon
              v-if="scope.row.milestone"
              icon-class="milestone"
              style="color: #FF7373; margin-right: -3px"
            ></svg-icon>
            <svg-icon
              v-if="scope.row.riskSet"
              icon-class="display_project-risk"
              style="color: #FF7373; margin-right: -3px"
              :style="scope.row.milestone ? 'margin-left: 5px' : ''"
            ></svg-icon>
            <span :class="{ 'is-complete': scope.row.completed }">
              <span v-html="emptyStr"></span>
              {{ scope.row[column.prop] }}
              <span v-html="emptyStr"></span>
            </span>
            <span
              v-if="projectInfo.publicMode && scope.row.publicMode === false"
              class="icon-public-mode"
            >
              <span class="svg-container">
                <svg-icon icon-class="public-mode" />
              </span>
              <span>隐私</span>
            </span>
            <div class="btn-group">
              <span v-if="scope.row.fileCount" class="file-count">
                {{ scope.row.fileCount }}
                <svg-icon class="clip-btn" icon-class="svgo_clip"></svg-icon>
              </span>
              <el-tooltip
                v-if="showAddBtn && !scope.row.isLeaf && hasCreateTask"
                content="建子任务"
              >
                <svg-icon
                  class="add-btn"
                  icon-class="plus"
                  @click.native.stop="openCreateDialg(scope.row)"
                ></svg-icon>
              </el-tooltip>
            </div>
          </template>
          <template v-else-if="column.prop === 'status'">
            <div class="status">
              <span v-show="scope.row.status === '已完成'" class="status-icon">
                <svg-icon icon-class="success" class="icon-finish"></svg-icon>
              </span>
              <span v-show="scope.row.status === '待审核'" class="status-icon">
                <svg-icon icon-class="need-verify" class="icon-need-verify"></svg-icon>
              </span>
              <span v-show="scope.row.status === '待处理'" class="status-icon">
                <span class="icon-round"></span>
              </span>
              {{ scope.row.status }}
            </div>
          </template>
          <template v-else-if="column.prop === 'dueDate'">
            <span :style="{ color: scope.row.dueDateColor }">
              {{ scope.row.dueDateStr }}
            </span>
          </template>
          <template v-else-if="column.prop === 'assigneeRole'">
            <span v-if="scope.row.assignProjectRole != undefined">
              {{ scope.row.assignProjectRole.name }}
            </span>
          </template>
          <template v-else-if="column.prop === 'startDate'">
            <span v-if="scope.row.startAt !== undefined">
              {{ scope.row.startAt.substr(0, 10) }}
            </span>
          </template>
          <template v-else-if="column.prop === 'priorityStr'">
            <span :class="['priority-box', 'level-' + scope.row.priority]">
              {{ scope.row[column.prop] }}
            </span>
          </template>
          <template v-else-if="column.prop === 'assigneeUser' && _.get(scope.row, column.prop)">
            <staff-popover :staffId="_.get(scope.row, column.prop).id" :placement="'top'">
              <template v-slot:reference>
                <span>{{ _.get(scope.row, column.prop).name }}</span>
              </template>
            </staff-popover>
          </template>
          <template v-else>
            {{ _.get(scope.row, column.prop) }}
          </template>
        </template>
      </el-table-column>
    </base-table>
    <!--用于创建子任务-->
    <edit-dialog
      v-if="from === 'project'"
      from="create"
      :project-id="projectId"
      :task-group="taskGroup"
      :parent-task="parentTask"
      :visible.sync="editDialogVisible"
      @after-submit="refreshTable"
    ></edit-dialog>
    <detail-dialog
      ref="detailDialog"
      :task-id="taskId"
      :visible.sync="detailDialogVisible"
      @data-changed="refreshTable"
      @trun-page="trunPage"
      :task-ids="tableDataIds"
    ></detail-dialog>
  </div>
</template>

<script>
import _ from "lodash"
import BaseTable from "@/components/UIComponents/BaseTable"
import { tableColumns } from "./static"
import * as TaskApi from "@/api/project/task"
import { getProject, getProjectMembers } from "@/api/project/project"
import { translateTaskList, changeTaskHeight, removeTasks, getTaskSortType } from "@/utils/project"
import { bfs } from "@/utils/algorithm"
import StaffPopover from "@/components/BaseComponents/StaffPopover"

export default {
  name: "task-table",
  components: { BaseTable, StaffPopover },
  data() {
    return {
      emptyStr: "&nbsp;",
      tableLoading: true,
      pageInfo: {
        total: 0,
        currentPage: 1,
        pageSize: 20
      },
      editDialogVisible: false,
      detailDialogVisible: false,
      parentTask: null,
      tableData: [],
      debouncedRefresh: null,
      taskId: "",
      projectInfo: {},
      initialLineHeightLevel: "2",
      columnCheckedId: "",
      multipleSelection: [],
      checkedList: [],
      hasCreateTask: false
    }
  },
  props: {
    from: {
      type: String,
      default: "project" // project/todoList/taskDetail/parent/selectPrev
    },
    projectId: String,
    taskGroup: Object,
    listType: String,
    searchInfo: Object,
    showSelection: {
      // 是否显示最前面的 selection 列
      type: Boolean,
      default: true
    },
    showPagination: {
      type: Boolean,
      default: true
    },
    showAddBtn: {
      type: Boolean,
      default: false
    },
    showDeleteBtn: {
      type: Boolean,
      default: false
    },
    showPointer: {
      // 移到表格的某一行上时，鼠标变成 pointer 的状态
      type: Boolean,
      default: true
    },
    // from为parent需要
    height: Number,
    childId: Array,
    // ignoreTaskId 选择依赖任务时需要(在结果中过滤掉所有与其相关的父子任务)
    ignoreTaskId: String
  },
  watch: {
    taskGroup: {
      deep: true,
      handler() {
        if (this.taskGroup?.id) this.debouncedRefresh()
      }
    },
    multipleSelection: {
      deep: true,
      handler() {
        // 表格内置多选变化之后回显
        this.multipleSelection.forEach(checkItem => {
          this.checkedList[checkItem.index] = true
        })
        if (this.multipleSelection.length === 0) {
          this.checkedList = []
        }
      }
    },
    listType() {
      this.debouncedRefresh()
    },
    searchItem() {
      this.debouncedRefresh()
    }
  },
  computed: {
    curUser() {
      return this.$store.getters.userInfo
    },
    searchItem() {
      if (this.searchInfo?.searchValue === null || this.searchInfo?.searchKey === null) return {}
      let t = {}
      t[this.searchInfo?.searchKey] = this.searchInfo?.searchValue
      return t
    },
    tableColumns() {
      let cols = tableColumns
      if (["ALL", "TODAY", "COMPLETED", "TIMEOUT"].includes(this.listType)) {
        cols = cols.concat([
          {
            label: "完成时间",
            prop: "completeAt",
            width: "100",
            contentAlign: "center"
          }
        ])
      }
      if (this.listType === "COMPLETED") {
        cols = cols.concat([
          {
            label: "完成人",
            prop: "completerUser.name",
            width: "100",
            contentAlign: "center"
          }
        ])
      }
      if (this.listType === "TIMEOUT") {
        cols = cols.concat([
          {
            label: "逾期天数",
            prop: "timeoutDay",
            width: "100",
            contentAlign: "center"
          }
        ])
      }
      return cols.filter(col => {
        return this.from === "todoList" || col.label !== "任务路径"
      })
    },
    tableDataIds() {
      return this.transTaskIds(this.tableData)
    },
    allParentTaskIds() {
      let arr = []
      bfs({
        arr: this.tableData,
        childFuc: task => task.children,
        cbk: task => {
          if (task._deep < 2) arr.push(task.id)
        }
      })
      return arr
    }
  },
  beforeCreate() {
    this.$options.components.EditDialog = require("@/components/Task/EditDialog").default
    this.$options.components.DetailDialog = require("@/components/Task/DetailDialog").default
  },
  created() {
    this.isHasCreateTask()
    if (this.from === "project") {
      getProject(this.projectId).then(res => {
        this.projectInfo = res
      })
    }
    this.debouncedRefresh = _.debounce(this.refreshTable, 50, {
      leading: false,
      trailing: true
    })
  },
  methods: {
    init(initTableData = null) {
      this.pageInfo.currentPage = 1
      if (initTableData) {
        this.tableLoading = false
        this.tableData = translateTaskList(initTableData)
      } else {
        this.debouncedRefresh()
      }
    },
    refreshTable() {
      this.tableLoading = false
      switch (this.from) {
        case "taskDetail":
          return
        case "parent":
          if (this.height <= 0) return
          break
        case "todoList":
          if (!this.listType) return
          break
        case "project":
          if (!this.listType) return
          if (!this.taskGroup?.id) return
          break
        default:
      }
      this.tableLoading = true
      let { key: sortBy, type: direction } = getTaskSortType(this.projectId)
      TaskApi.getTaskList({
        ...this.searchItem,
        listType: this.listType,
        groupId: this.taskGroup?.id,
        projectId: this.projectId, // 选择前置任务时,传入projectId,不传入groupId
        ignoreTaskId: this.ignoreTaskId,
        sortBy,
        direction,
        page: this.pageInfo.currentPage - 1,
        size: this.pageInfo.pageSize
      })
        .then(taskList => {
          let content = taskList.content
          if (this.from === "parent") {
            changeTaskHeight(content, this.height)
            content = removeTasks(content, this.childId)
          }
          this.pageInfo.total = taskList.totalElements
          translateTaskList(content).forEach((item, index) => {
            // 初始index加上之前页数的长度
            item.index = index + (this.pageInfo.currentPage - 1) * 20 + 1
            if (item?.children !== undefined) {
              item.children.forEach((childItem, childindex) => {
                childItem.index = item.index + "." + (childindex + 1)
                if (childItem?.children !== undefined) {
                  childItem.children.forEach((i, idx) => {
                    i.index = childItem.index + "." + (idx + 1)
                  })
                }
              })
            }
          })
          this.tableData = translateTaskList(content)
          this.$nextTick(() => this.$refs.baseTable?.$refs.elTable?.doLayout())
        })
        .finally(() => (this.tableLoading = false))
    },
    pageChange() {
      this.debouncedRefresh()
    },
    async isHasCreateTask() {
      // 获取新建权限
      let createRoleList = await getProject(this.projectId).then(res => res?.privilege?.roleList)
      if (createRoleList === null || createRoleList === undefined || createRoleList.length === 0) {
        this.hasCreateTask = true
        return
      }
      // 获取用户权限
      let userRoleList = await getProjectMembers(this.projectId).then(members => {
        return members.find(member => member.userId === this.curUser.userId).roles
      })
      if (this._.intersection(createRoleList, userRoleList).length > 0) this.hasCreateTask = true
      else this.hasCreateTask = false
    },
    rowClick(row, col) {
      if (col.type === "selection") return
      if (Object.prototype.hasOwnProperty.call(this.$listeners, "row-click")) {
        this.$emit("row-click", row)
        return
      }
      this.taskId = row.id
      this.detailDialogVisible = true
    },
    trunPage(dataId) {
      this.taskId = dataId
      this.$nextTick(() => this.$refs.detailDialog.init())
    },
    openCreateDialg(row) {
      this.parentTask = row
      this.editDialogVisible = true
    },
    transTaskIds(tasks) {
      if (!tasks) return []
      let res = []
      tasks.forEach(task => {
        res.push(task.id)
        res = res.concat(this.transTaskIds(task.children))
      })
      return res
    },
    toggleExpansion(expand) {
      this.allParentTaskIds.forEach(taskId => {
        this.$refs.baseTable.toggleRowExpansion({ id: taskId }, expand)
      })
    },
    space(val) {
      this.initialLineHeightLevel = val.toString()
    },
    handleSelectAllChange(selection) {
      if (selection && selection.length === this.tableData.length) {
        selection.forEach(val => {
          this.selectChange(val, true)
        })
      } else {
        selection.forEach(val => {
          this.selectChange(val, false)
        })
      }
    },
    selectChange(val, bool) {
      this.checkedList[val.index] = bool
      if (val.children) {
        val.children.forEach(v => {
          // 将checkList也同步赋值
          this.$refs.baseTable.$refs.elTable.toggleRowSelection(v, bool)
          this.checkedList[v.index] = bool
          if (v.children) {
            this.selectChange(v, bool)
          }
        })
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (this.multipleSelection.length === this.tableData.length) {
        this.multipleSelection.forEach(item => {
          this.checkedList[item.index] = true
        })
      }
      if (this.multipleSelection.length === 0) {
        this.checkedList = []
      }
      this.$emit("selection-change", this.multipleSelection)
    },
    // 鼠标移入移出判断是否显示勾选框
    cellEnter(row, column, cell, event) {
      if (column.type === "selection") this.columnCheckedId = row.id
    },
    cellLeave(row, column, cell, event) {
      if (column.type === "selection") this.columnCheckedId = ""
    },
    changeCheckVal(bool, row) {
      this.$refs.baseTable.$refs.elTable.toggleRowSelection(row, bool)
      if (row.children) {
        row.children.forEach(val => {
          this.checkedList[val.index] = bool
          this.$refs.baseTable.$refs.elTable.toggleRowSelection(val, bool)
          if (val.children) {
            val.children.forEach(v => {
              this.checkedList[v.index] = bool
              this.$refs.baseTable.$refs.elTable.toggleRowSelection(v, bool)
            })
          }
        })
      }
    },
    // 选择行数据
    cellCheckbox(row) {
      if (this.checkedList[row.index]) {
        this.changeCheckVal(true, row)
      } else {
        this.changeCheckVal(false, row)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.task-table {
  display: flex;
  flex-flow: column;
  align-items: stretch;
  overflow: hidden;

  .base-table {
    flex: 1;
    overflow: hidden;

    .icon-public-mode {
      font-size: 12px;
      line-height: 12px;
      padding: 1px 3px;
      display: inline-block;
      border-radius: 13px;
      border: 1px solid #c0c4cc;
      color: $color-font-second;
    }
  }

  .el-table__row {
    .is-complete {
      color: $color-font-second;
      position: relative;
      text-decoration: line-through;
    }

    .status {
      @include flex-center;

      .status-icon {
        font-size: 16px;
        margin-right: 8px;
      }

      .icon-need-verify {
        color: #ffa150;
      }

      .icon-finish {
        color: #69e0af;
      }

      .icon-round {
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
      }
    }

    .priority-box {
      box-sizing: border-box;
      padding: 3px 10px;
      border-radius: 12px;
      background-color: #fff;
      @mixin priority-box($color) {
        color: $color;
        border: 1px solid rgba($color, 0.5);
        background-color: rgba($color, 0.1);
      }

      &.level-0 {
        @include priority-box(#606266);
      }

      &.level-1 {
        @include priority-box(#1989fa);
      }

      &.level-2 {
        @include priority-box(#ffa150);
      }

      &.level-3 {
        @include priority-box(#ff7373);
      }
    }
  }

  ::v-deep {
    .el-table__body tr.hover-row > td {
      .btn-group {
        //background-color: #f5f7fa;
        padding-left: 10px;

        .add-btn {
          display: inline-block !important;
        }
      }
    }

    .cell {
      .btn-group {
        display: inline-block;
        font-size: 14px;
        position: absolute;
        right: 15px;
        height: 23px;

        .file-count {
          color: $color-font-second;
        }

        .clip-btn {
          position: relative;
          left: -5px;
        }

        .add-btn {
          display: none;

          &:hover {
            color: $color-main;
          }
        }
      }
    }
  }
}
</style>
